import * as React from "react";
const SvgFiBrandsIllustratorDraw = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-brands-illustrator-draw_svg__a)">
      <path
        fill="#151A2D"
        fillRule="evenodd"
        d="M19.886.333H3.687C.691.333 0 2.116 0 5.115l.013 14.552c0 3 .934 4 3.929 4h16.057c2.995 0 4.001-1.001 4.001-3.999V4.564C24 1.566 22.881.333 19.886.333m-8.5 5.732h2.323c0 1.295 1.543 3.196 2.193 3.573l-2.967 5.599h-.067v-3.803a.86.86 0 0 0 .555-.811.886.886 0 0 0-.889-.863.868.868 0 0 0-.313 1.675v3.801h-.041L9.193 9.624c.543-.459 2.193-2.48 2.193-3.559m8.315.281-6.973 12.558a.224.224 0 0 1-.302.086.2.2 0 0 1-.073-.068l-.003-.005S4.745 7.831 4.554 7.563a.92.92 0 0 1-.252-.631.91.91 0 0 1 .907-.915c.392.001.626.242.869.655l6.46 11.662L19.314 6.13h.001a.22.22 0 0 1 .301-.085c.106.06.144.194.085.301"
        clipRule="evenodd"
      />
    </g>
    <defs>
      <clipPath id="fi-brands-illustrator-draw_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiBrandsIllustratorDraw;
